export const translations = {
  de: {
    nav: {
      features: "Features",
      how: "So funktioniert's",
      faq: "FAQ",
      privacy: "Datenschutz",
      terms: "Nutzerbedingungen",
      imprint: "Impressum"
    },
    store: {
      appleTop: "Laden im",
      appleName: "App Store",
      playTop: "Jetzt bei",
      playName: "Google Play"
    },
    hero: {
      badge: "Für Familien, WGs & Paare",
      titlePre: "Nie wieder streiten,",
      titleHi: "was es zu essen gibt.",
      subtitle:
        "«Was gits hüt?» – die Frage zu jeder Mahlzeit. Mit WasGitsHüt? entscheidet ihr gemeinsam und ohne Diskussionen, was auf den Tisch kommt – ob Frühstück, Zmittag, Znacht oder Snack. Zutaten eintippen oder Kühlschrank abfotografieren, Gusti liefert die Ideen, alle stimmen live ab.",
      qr1: "QR-Code",
      qr2: "folgt in Kürze",
      rating: "Kochen wird wieder zur Teamsache."
    },
    phone: {
      household: "Familie Meier",
      title: "Gusti schlägt vor",
      voting: "4 stimmen gerade live ab",
      cook: "Gewinner kochen",
      ideas: "Rezept-Ideen",
      recipes: [
        { name: "Zürcher Geschnetzeltes", meta: "35 Min · Schweizerisch" },
        { name: "Pasta al Pomodoro", meta: "25 Min · Mediterran" },
        { name: "Soba-Nudel-Bowl", meta: "20 Min · Asiatisch" }
      ]
    },
    problem: {
      badge: "Das Problem",
      overlay: "Schluss mit «Weiss nöd»!",
      title: "Die Frage «Was gits hüt?» kostet jeden Tag Nerven.",
      pains: [
        "«Ich weiss auch nicht… was willsch du?»",
        "Der Kühlschrank ist voll – trotzdem keine Idee.",
        "Jeder will etwas anderes, niemand entscheidet."
      ],
      text:
        "WasGitsHüt? nimmt euch die Entscheidung ab – gemeinsam, in Sekunden und mit richtig Lust aufs Essen. Ihr sagt, was da ist, Gusti macht drei passende Vorschläge, und ihr wählt zusammen den Sieger."
    },
    features: {
      badge: "Features",
      title: "Alles, was gemeinsames Kochen einfacher macht.",
      subtitle:
        "Von der Zutaten-Erkennung bis zur Live-Abstimmung – WasGitsHüt? bringt euch schnell und entspannt zur fertigen Mahlzeit, ob Frühstück, Zmittag oder Znacht.",
      items: [
        { title: "Gusti kocht Ideen", text: "Gusti schlägt dir passende Rezepte vor – abgestimmt auf eure Zutaten, Allergien und Vorlieben." },
        { title: "Zutaten per Foto", text: "Fotografiere deinen Kühlschrank oder Vorrat – die App erkennt deine Zutaten automatisch." },
        { title: "Live-Abstimmung", text: "Alle stimmen in Echtzeit ab. Seht sofort, wer mitmacht und welches Rezept gewinnt." },
        { title: "Länderküchen", text: "Von Schweizerisch über Mediterran bis Asiatisch – wählt die Küche, auf die ihr Lust habt." },
        { title: "Rezepte speichern", text: "Sichere eure Lieblingsrezepte und findet sie jederzeit ganz einfach wieder." },
        { title: "Haushalte & Gäste", text: "Erstelle einen Haushalt und lade Familie, WG oder Gäste bequem per Link ein." },
        { title: "Persönliches Essprofil", text: "Hinterlege Allergien, Ernährungsform und Vorlieben – für Vorschläge, die wirklich passen." },
        { title: "Heller & dunkler Modus", text: "Nutze die App so, wie es dir gefällt – im hellen oder dunklen Design." }
      ]
    },
    how: {
      badge: "So funktioniert's",
      title: "In sechs Schritten zur fertigen Mahlzeit.",
      subtitle:
        "Egal ob Frühstück, Zmittag, Znacht oder ein schneller Snack – so kommt ihr gemeinsam vom Hunger zum fertigen Gericht.",
      steps: [
        { title: "Haushalt erstellen & einladen", text: "Erstelle deinen Haushalt und hol Familie, WG oder Partner:in per Link dazu – z. B. direkt über WhatsApp." },
        { title: "Zutaten & Küche wählen", text: "Tippe vorhandene Zutaten ein oder fotografiere einfach deinen Kühlschrank. Danach wählt ihr eure Länderküche und die passende Mahlzeit." },
        { title: "Gusti schlägt Ideen vor", text: "Gusti schlägt euch drei passende Rezepte vor – ob Frühstück, Zmittag, Znacht oder Snack, jeweils mit appetitlichem Bild." },
        { title: "Live abstimmen", text: "Alle stimmen in Echtzeit ab. Das Gericht mit den meisten Stimmen gewinnt – Lieblingsrezepte könnt ihr speichern." },
        { title: "Kochmodus starten", text: "Startet den Schritt-für-Schritt-Kochmodus und kocht das Gewinner-Gericht ganz entspannt gemeinsam nach." },
        { title: "Gemeinsam geniessen", text: "Setzt euch zusammen an den Tisch und lasst es euch schmecken – vom Frühstück bis zum Znacht." }
      ]
    },
    privacy: {
      badge: "Datenschutz",
      title: "Deine Kühlschrank-Fotos bleiben deine Sache.",
      subtitle:
        "Wir wissen, dass ein Blick in den Kühlschrank privat ist. Darum gehen wir mit deinen Fotos so sparsam wie möglich um.",
      points: [
        { title: "Nur zur Erkennung", text: "Dein Foto dient ausschliesslich dazu, die enthaltenen Zutaten zu erkennen." },
        { title: "Sofort verworfen", text: "Direkt nach der Erkennung wird das Bild automatisch wieder gelöscht." },
        { title: "Nirgendwo gespeichert", text: "Deine Fotos werden nicht abgelegt und nicht weitergegeben. Punkt." }
      ],
      alt: "Blick in einen gefüllten Kühlschrank"
    },
    gallery: {
      badge: "Ein Blick in die App",
      title: "So schön werden eure Vorschläge serviert.",
      captions: [
        "Beeren-Frühstücksbowl",
        "Hausgemachte Pizza",
        "Cremiges Curry",
        "Bunte Tacos",
        "Herzhafte Gemüsesuppe"
      ]
    },
    about: {
      badge: "Über uns",
      title: "Gemacht mit Herzblut von der Liberox GmbH.",
      text:
        "WasGitsHüt? ist eine Marke der Liberox GmbH aus der Schweiz. Wir glauben, dass gemeinsames Essen verbindet – und dass die Frage «Was gits hüt?» kein Streitthema sein sollte, sondern der Startschuss für einen schönen Abend.",
      stats: [
        { k: "3", v: "Rezept-Ideen pro Runde" },
        { k: "∞", v: "Länderküchen & Kombis" },
        { k: "iOS", v: "& Android" },
        { k: "0 Fr.", v: "Download kostenlos" }
      ]
    },
    footer: {
      ctaTitle: "Bereit? Dann: Was gits hüt?",
      ctaText:
        "Lade WasGitsHüt? kostenlos herunter und entscheidet ab heute gemeinsam – ohne Diskussionen.",
      qrTitle: "QR-Code folgt bald",
      qrText:
        "Sobald die App live ist, könnt ihr sie hier per QR-Code direkt laden.",
      qrBadge: "QR folgt",
      tagline:
        "Die App für Familien, WGs und Paare, um gemeinsam zu entscheiden, was gekocht wird.",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten."
    },
    faqPage: {
      title: "Häufige Fragen",
      subtitle: "Alles Wichtige rund um WasGitsHüt? auf einen Blick.",
      items: [
        { q: "Ist die App kostenlos?", a: "WasGitsHüt? kannst du kostenlos herunterladen und die wichtigsten Funktionen sofort nutzen." },
        { q: "Auf welchen Geräten läuft die App?", a: "Die App ist für iPhone (iOS) und Android-Smartphones verfügbar – lade sie im App Store oder bei Google Play herunter." },
        { q: "Wie funktioniert die Zutaten-Erkennung per Foto?", a: "Du fotografierst deinen Kühlschrank oder Vorrat, und die App erkennt die enthaltenen Zutaten automatisch und schlägt passende Rezepte vor." },
        { q: "Was passiert mit meinen Fotos?", a: "Deine Fotos werden ausschliesslich zur Zutaten-Erkennung genutzt, sofort danach verworfen und nirgendwo gespeichert." },
        { q: "Kann ich mit mehreren Personen zusammen entscheiden?", a: "Ja! Erstelle einen Haushalt, lade weitere Mitglieder ein und stimmt gemeinsam in Echtzeit ab, was gekocht wird." },
        { q: "Kann ich Allergien und Vorlieben hinterlegen?", a: "Ja. In deinem persönlichen Essprofil hinterlegst du Allergien, Ernährungsform und Vorlieben – die Rezeptvorschläge berücksichtigen das." }
      ]
    }
  },

  en: {
    nav: {
      features: "Features",
      how: "How it works",
      faq: "FAQ",
      privacy: "Privacy",
      terms: "Terms",
      imprint: "Imprint"
    },
    store: {
      appleTop: "Download on the",
      appleName: "App Store",
      playTop: "Get it on",
      playName: "Google Play"
    },
    hero: {
      badge: "For families, flatshares & couples",
      titlePre: "Stop arguing about",
      titleHi: "what to eat.",
      subtitle:
        "«Was gits hüt?» – the question at every meal. With WasGitsHüt? you decide together and without arguing what ends up on the table – whether breakfast, lunch, dinner or a snack. Type in your ingredients or snap a photo of your fridge, Gusti delivers the ideas, and everyone votes live.",
      qr1: "QR code",
      qr2: "coming soon",
      rating: "Cooking is a team effort again."
    },
    phone: {
      household: "The Meier Family",
      title: "Gusti suggests",
      voting: "4 people voting live",
      cook: "Cook the winner",
      ideas: "recipe ideas",
      recipes: [
        { name: "Zürcher Geschnetzeltes", meta: "35 min · Swiss" },
        { name: "Pasta al Pomodoro", meta: "25 min · Mediterranean" },
        { name: "Soba Noodle Bowl", meta: "20 min · Asian" }
      ]
    },
    problem: {
      badge: "The problem",
      overlay: "No more «dunno»!",
      title: "The daily question «what's for dinner?» costs you nerves.",
      pains: [
        "«I don't know either… what do you want?»",
        "The fridge is full – and still no idea.",
        "Everyone wants something different, no one decides."
      ],
      text:
        "WasGitsHüt? takes the decision off your hands – together, in seconds and with real appetite. You say what's there, Gusti makes three fitting suggestions, and you pick the winner together."
    },
    features: {
      badge: "Features",
      title: "Everything that makes cooking together easier.",
      subtitle:
        "From ingredient recognition to live voting – WasGitsHüt? gets you to a finished meal quickly and stress-free, whether breakfast, lunch or dinner.",
      items: [
        { title: "Gusti cooks up ideas", text: "Gusti suggests fitting recipes – tailored to your ingredients, allergies and preferences." },
        { title: "Ingredients by photo", text: "Take a photo of your fridge or pantry – the app recognises your ingredients automatically." },
        { title: "Live voting", text: "Everyone votes in real time. See instantly who's joining in and which recipe wins." },
        { title: "World cuisines", text: "From Swiss to Mediterranean to Asian – pick the cuisine you're in the mood for." },
        { title: "Save recipes", text: "Save your favourite recipes and find them again anytime with ease." },
        { title: "Households & guests", text: "Create a household and invite family, flatmates or guests easily via link." },
        { title: "Personal food profile", text: "Store allergies, diet and preferences – for suggestions that really fit." },
        { title: "Light & dark mode", text: "Use the app just the way you like it – in a light or dark design." }
      ]
    },
    how: {
      badge: "How it works",
      title: "Six steps to a finished meal.",
      subtitle:
        "Whether breakfast, lunch, dinner or a quick snack – this is how you go from hungry to a finished dish, together.",
      steps: [
        { title: "Create a household & invite", text: "Create your household and bring in family, flatmates or your partner via link – e.g. directly through WhatsApp." },
        { title: "Choose ingredients & cuisine", text: "Type in the ingredients you have or simply snap a photo of your fridge. Then you pick your cuisine and the right meal." },
        { title: "Gusti suggests ideas", text: "Gusti suggests three fitting recipes – breakfast, lunch, dinner or snack, each with an appetising photo." },
        { title: "Vote live", text: "Everyone votes in real time. The dish with the most votes wins – and you can save your favourites." },
        { title: "Start cooking mode", text: "Start the step-by-step cooking mode and cook the winning dish together, nice and relaxed." },
        { title: "Enjoy together", text: "Sit down at the table together and dig in – from breakfast to dinner." }
      ]
    },
    privacy: {
      badge: "Privacy",
      title: "Your fridge photos stay your business.",
      subtitle:
        "We know a look inside your fridge is private. That's why we handle your photos as sparingly as possible.",
      points: [
        { title: "Only for recognition", text: "Your photo is used solely to recognise the ingredients it contains." },
        { title: "Discarded immediately", text: "Right after recognition the image is automatically deleted again." },
        { title: "Stored nowhere", text: "Your photos are not stored and not passed on. Period." }
      ],
      alt: "A look inside a well-stocked fridge"
    },
    gallery: {
      badge: "A look inside the app",
      title: "This is how beautifully your suggestions are served.",
      captions: [
        "Berry breakfast bowl",
        "Homemade pizza",
        "Creamy curry",
        "Colourful tacos",
        "Hearty vegetable soup"
      ]
    },
    about: {
      badge: "About us",
      title: "Made with love by Liberox GmbH.",
      text:
        "WasGitsHüt? is a brand of Liberox GmbH from Switzerland. We believe that eating together connects people – and that the question «what's for dinner?» shouldn't be a source of conflict, but the start of a lovely evening.",
      stats: [
        { k: "3", v: "recipe ideas per round" },
        { k: "∞", v: "cuisines & combos" },
        { k: "iOS", v: "& Android" },
        { k: "Free", v: "download at no cost" }
      ]
    },
    footer: {
      ctaTitle: "Ready? So: what's for dinner?",
      ctaText:
        "Download WasGitsHüt? for free and start deciding together from today – without arguing.",
      qrTitle: "QR code coming soon",
      qrText:
        "As soon as the app is live, you'll be able to download it here directly via QR code.",
      qrBadge: "QR soon",
      tagline:
        "The app for families, flatshares and couples to decide together what to cook.",
      contact: "Contact",
      rights: "All rights reserved."
    },
    faqPage: {
      title: "Frequently asked questions",
      subtitle: "Everything important about WasGitsHüt? at a glance.",
      items: [
        { q: "Is the app free?", a: "You can download WasGitsHüt? for free and use the most important features right away." },
        { q: "Which devices does the app run on?", a: "The app is available for iPhone (iOS) and Android smartphones – download it from the App Store or Google Play." },
        { q: "How does photo-based ingredient recognition work?", a: "You take a photo of your fridge or pantry, and the app automatically recognises the ingredients it contains and suggests fitting recipes." },
        { q: "What happens to my photos?", a: "Your photos are used solely for ingredient recognition, discarded immediately afterwards and stored nowhere." },
        { q: "Can I decide together with several people?", a: "Yes! Create a household, invite more members and vote together in real time on what to cook." },
        { q: "Can I store allergies and preferences?", a: "Yes. In your personal food profile you store allergies, diet and preferences – the recipe suggestions take these into account." }
      ]
    }
  }
};
